<template>
  <div class="uploadImgs">
    <el-upload
      :action="action"
      list-type="picture-card"
      :on-remove="handleRemove"
      multiple
      :on-success="handleAvatarSuccess"
      :file-list="fileList"
      :disabled="disabled"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
  </div>
</template>

<script>
import { uploadPartyPhoto } from "@/api/requrestHttp.js";
import { uploadImg } from "@/api/baseURL.js";
export default {
  name: "uploadImgs",
  data() {
    return { action: uploadImg, fileList: [], list: [] };
  },
  props: {
    value: {
      default: ""
    },
    disabled: {
      default: false
    },
    off: {
      default: true
    },
    Separate: {
      default: '#'
    }
  },
  methods: {
    handleRemove(file, fileList) {
      this.list.forEach((item, index) => {
          let url = file.response?file.response.content:file.url;
        if (item == url) {
          this.list.splice(index, 1);
        }
      });
      this.$emit("offFalse", false);
      this.$emit("input", this.list.join(this.Separate));
    },
    handleAvatarSuccess(res, file, fileList) {
      this.$emit("offFalse", false);
      this.list.push(res.content);
      this.$emit("input", this.list.join(this.Separate));
    }
  },
  mounted() {
    // this.list = this.value.split("#");
    setTimeout(() => {
      this.$emit("offFalse", false);
    }, 1000);
  },
  updated() {},
  created() {
    if (this.value == "" || !this.value) {
      this.list = [];
      this.fileList = [];
    } else {
      this.list = this.value.split(this.Separate);
      this.fileList = [];
      this.list.forEach(element => {
        if (element != "") {
          this.fileList.push({
            url: element
          });
        }
      });
    }
    setTimeout(() => {
      this.$emit("offFalse", false);
    }, 1000);
  },
  watch: {
    value: function(newVal, oldVal) {
      // console.log(this.off);
      // if (this.value == "") {
      //     this.list = [];
      //     this.fileList = [];
      // }
      // if (this.off) {
      //     this.list = newVal.split("#");
      //     this.fileList = [];
      //     this.list.forEach(element => {
      //         this.fileList.push({
      //             url: element
      //         });
      //     });
      // }
      // this.$emit("offFalse", false);
      // if (this.off) {
      //     if (this.value == "") {
      //         this.list = [];
      //         this.fileList = [];
      //     } else {
      //         this.list = this.value.split("#");
      //         this.fileList = [];
      //         this.list.forEach(element => {
      //             if (element != "") {
      //                 this.fileList.push({
      //                     url: element
      //                 });
      //             }
      //         });
      //     }
      // }
      setTimeout(() => {
        this.$emit("offFalse", false);
      }, 1000);
    },
    off: function(newVal) {
      if (this.off) {
        if (!this.value) {
          this.list = [];
          this.fileList = [];
        } else {
          this.list = this.value.split(this.Separate);
          this.fileList = [];
          this.list.forEach(element => {
            if (element != "") {
              this.fileList.push({
                url: element
              });
            }
          });
        }
      }
      setTimeout(() => {
        this.$emit("offFalse", false);
      }, 1000);
    }
  }
};
</script>
<style lang="less">
.uploadImgs {
  .el-upload-list__item {
    transition: none;
  }
}
</style>
